// Attachments that stay inside Hudson. The issue form's other file field is
// served to the manager dashboard; this one is stored in its own column and is
// only ever returned to the tech and office endpoints, so supplier quotes and
// internal pricing can be kept against the issue they belong to.
import React, { useRef } from 'react';
import { FaLock } from 'react-icons/fa';

const LABEL_STYLE = { display: 'block', marginBottom: '0.4rem', fontWeight: 600, fontSize: '1rem', color: '#374151' };

export default function MechInternalFilesField({ files, setFiles, onAdd }) {
  const inputRef = useRef(null);

  return (
    <div>
      <label style={LABEL_STYLE}>Internal Files</label>
      <div style={{ fontSize: '0.85rem', color: '#6b7280', margin: '-0.2rem 0 0.5rem' }}>
        Hudson office only — never shown on the manager's dashboard.
      </div>

      <div onClick={() => inputRef.current?.click()}
        style={{ border: '2px dashed #d6d9e0', borderRadius: '10px', padding: '0.85rem', textAlign: 'center', cursor: 'pointer', background: '#fff' }}>
        <FaLock style={{ fontSize: '1.1rem', color: '#9ca3af', marginBottom: '0.2rem' }} />
        <div style={{ fontSize: '1rem', color: '#6b7280' }}>Tap to add internal files</div>
      </div>
      <input ref={inputRef} type="file" accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,.csv,image/*" multiple style={{ display: 'none' }}
        onChange={(e) => { onAdd(Array.from(e.target.files)); e.target.value = ''; }} />

      {files.length > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem', marginTop: '0.5rem' }}>
          {files.map((f, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem 0.7rem', background: '#eef2f8', border: '1px solid #dbe2ee', borderRadius: '8px', fontSize: '0.95rem', color: '#374151' }}>
              <FaLock style={{ color: '#1F3A68', flexShrink: 0, fontSize: '0.85rem' }} />
              <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{f.name}</span>
              {f.type === 'existing' && (
                <a href={f.url} target="_blank" rel="noreferrer" style={{ fontSize: '0.85rem', color: '#2563eb', fontWeight: 600, textDecoration: 'none', flexShrink: 0 }}>Open</a>
              )}
              <button type="button" aria-label={`Remove ${f.name}`} onClick={() => setFiles((prev) => prev.filter((_, j) => j !== i))}
                style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#dc2626', fontWeight: 700, fontSize: '1rem' }}>×</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// Both issue forms read attachments the same way; kept here so the two stay in
// step with what the server expects.
export function readFilesAsBase64(fileList, setter) {
  for (const file of fileList) {
    const reader = new FileReader();
    reader.onload = () => {
      setter((prev) => [...prev, {
        type: 'new', name: file.name, mimeType: file.type,
        data: reader.result.split(',')[1], size: file.size,
      }]);
    };
    reader.readAsDataURL(file);
  }
}
